export default __webpack_public_path__ + "static/1-c0348e13659352afe915db396784d5c1.png";